import { render, staticRenderFns } from "./FrejaOrgID.vue?vue&type=template&id=30d36cba&"
import script from "./FrejaOrgID.vue?vue&type=script&lang=js&"
export * from "./FrejaOrgID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports